module.exports = "/images/seller-welcome-3.jpg?a394522f1a978c07415ebfa8d798896e";